import React from 'react';
import { EditorState, RichUtils, getDefaultKeyBinding, convertToRaw, convertFromRaw, AtomicBlockUtils, Modifier } from 'draft-js';

import Editor , { composeDecorators } from 'draft-js-plugins-editor';
import createImagePlugin from 'draft-js-image-plugin';
import createVideoPlugin from 'draft-js-video-plugin';
import createResizeablePlugin from 'draft-js-resizeable-plugin';
import createBlockDndPlugin from 'draft-js-drag-n-drop-plugin';
import createInlineToolbarPlugin from 'draft-js-inline-toolbar-plugin';
import createLinkPlugin from 'draft-js-anchor-plugin';
import createFocusPlugin from 'draft-js-focus-plugin';
import createAlignmentPlugin from 'draft-js-alignment-plugin';

import editorStyles from './editor.css.js'
import { mediaBlockRenderer } from './entities/mediaBlockRenderer'

import PhotoModal from './photo-modal';
import ExcerptEditor from './excerpt-editor'
import HeaderStyleDropdown from './headerstyle-dropdown';

import {
    Row,
    Col,
    Button,
    Input,
    Spin,
    Icon,
    message,
    Tooltip,
    Divider,
    Affix,
    Modal
} from 'antd'

const { info } = Modal

// PLUGINS 
const linkPlugin = createLinkPlugin({
  placeholder: 'http://...',
  linkTarget: '_blank'
});
const inlineToolbarPlugin = createInlineToolbarPlugin();
const { InlineToolbar } = inlineToolbarPlugin;

const focusPlugin = createFocusPlugin();
const resizeablePlugin = createResizeablePlugin();
const blockDndPlugin = createBlockDndPlugin();

const alignmentPlugin = createAlignmentPlugin();
const { AlignmentTool } = alignmentPlugin;

let decorator = composeDecorators(
  alignmentPlugin.decorator,
  focusPlugin.decorator,
  resizeablePlugin.decorator,
  blockDndPlugin.decorator
);

const imagePlugin = createImagePlugin({ decorator });
const videoPlugin = createVideoPlugin();
const { types } = videoPlugin;

const plugins = [
  imagePlugin,
  videoPlugin,
  resizeablePlugin,
  blockDndPlugin,
  inlineToolbarPlugin,
  linkPlugin,
  focusPlugin,
  alignmentPlugin,
];

class EezeeEditor extends React.Component {
  componentWillReceiveProps(nextProps){

      if( !nextProps.activeDoc.text ){
        return
      }
      
      const parsedText =  JSON.parse(nextProps.activeDoc.text) 
      const content = convertFromRaw(parsedText)
      const editorState = EditorState.createWithContent(content)

      console.log(parsedText)
      
      this.setState({
        title: nextProps.activeDoc.title,
        showPhotoModal: false,
        editorState,
        customExcerpt: nextProps.activeDoc.excerpt,
        images: Object.values(parsedText.entityMap).filter( _entity => _entity.type == "image" ).map( _entity =>  _entity.data.src),
        videos: Object.values(parsedText.entityMap).filter( _entity => _entity.type != "image" ).map( _entity =>  _entity.data.src)
      })
  
    }
    
  constructor(props) {
    super(props);

    let editorState

    if( props.activeDoc.text ){

        const content = convertFromRaw( JSON.parse(this.props.activeDoc.text) )
        editorState = EditorState.createWithContent(content)

    } else {
        editorState = EditorState.createEmpty()
    }

    this.state = {
        title: props.activeDoc.title,
        editorState,
        customExcerpt: false,
        images: []
    };

    this.focus = () => this.refs.editor.focus();
    this.onChange = (editorState) => this.setState({editorState});
    this.handleKeyCommand = this._handleKeyCommand.bind(this);
    this.mapKeyToEditorCommand = this._mapKeyToEditorCommand.bind(this);
    this.toggleBlockType = this._toggleBlockType.bind(this);
    this.toggleInlineStyle = this._toggleInlineStyle.bind(this);
    this.onTab = this.onTab.bind(this);

  }

  _handleKeyCommand(command, editorState) {
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      this.onChange(newState);
      return true;
    }
    return false;
  }

  _mapKeyToEditorCommand(e) {
    if (e.keyCode === 9 /* TAB */) {
      const newEditorState = RichUtils.onTab(
        e,
        this.state.editorState,
        4, /* maxDepth */
      );
      if (newEditorState !== this.state.editorState) {
        this.onChange(newEditorState);
      }
      return;
    }
    return getDefaultKeyBinding(e);
  }

  _toggleBlockType(blockType) {
    this.onChange(
      RichUtils.toggleBlockType(
        this.state.editorState,
        blockType
      )
    );
  }

  _toggleInlineStyle(inlineStyle) {
    this.onChange(
      RichUtils.toggleInlineStyle(
        this.state.editorState,
        inlineStyle
      )
    );
  }

  onTab = (e) => {
    e.preventDefault();
    let currentState = this.state.editorState

    const selection = currentState.getSelection();
    const blockType = currentState
        .getCurrentContent()
        .getBlockForKey(selection.getStartKey())
        .getType();
    if(blockType === "unordered-list-item" || blockType === "ordered-list-item"){
        this.onChange(RichUtils.onTab(e, currentState, 3));
    }else{
        let newContentState = Modifier.replaceText(
            currentState.getCurrentContent(),
            currentState.getSelection(),
            '    '
        );
        
        this.onChange(EditorState.push(currentState, newContentState, 'insert-characters'))
    }
  }
  
  /* Original Script to add Image to Rich Editor */
  // onAddImage = (e) => {
  //   e.preventDefault();
  //   const editorState = this.state.editorState;
  //   const urlValue = window.prompt("Paste Image Link");
  //   const contentState = editorState.getCurrentContent();
  //   const contentStateWithEntity = contentState.createEntity(
  //     "image",
  //     "IMMUTABLE",
  //     { src: urlValue }
  //   );
  //   const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  //   const newEditorState = EditorState.set(
  //     editorState,
  //     { currentContent: contentStateWithEntity },
  //     "create-entity"
  //   );
  //   this.setState(
  //     {
  //     editorState: AtomicBlockUtils.insertAtomicBlock(
  //       newEditorState,
  //       entityKey,
  //       " "
  //     )
  //     },
  //     () => {
  //     setTimeout(() => this.focus(), 0);
  //     }
  //   );
  // };

  onAddImage = (imageUrl) => {
    
    const editorState = this.state.editorState;
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity(
      "image",
      "IMMUTABLE",
      { src: imageUrl }
    );
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    const newEditorState = EditorState.set(
      editorState,
      { currentContent: contentStateWithEntity },
      "create-entity"
    );
    this.setState(
      {
      editorState: AtomicBlockUtils.insertAtomicBlock(
        newEditorState,
        entityKey,
        " "
      ),
      images:  this.state.images.includes(imageUrl)? this.state.images: [...this.state.images, imageUrl]
      },
      () => {
      setTimeout(() => this.focus(), 0);
      }
    );
  };

  onAddVideo = (videoUrl) => {
    
    const editorState = this.state.editorState;
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity(
      types.VIDEOTYPE,
      "IMMUTABLE",
      { src: videoUrl }
    );
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    const newEditorState = EditorState.set(
      editorState,
      { currentContent: contentStateWithEntity },
      "create-entity"
    );
    this.setState(
      {
      editorState: AtomicBlockUtils.insertAtomicBlock(
        newEditorState,
        entityKey,
        " "
      ),
      videos: this.state.videos.includes(videoUrl)? this.state.videos: [...this.state.videos, videoUrl]
      },
      () => {
      setTimeout(() => this.focus(), 0);
      }
    );
  };

  handlePost = () => {
    console.log('handlePost called!')
    var contentState = this.state.editorState.getCurrentContent();
    const content = convertToRaw(contentState)
    const excerpt = this.state.customExcerpt || content.blocks.reduce((acc, curr) => acc += curr.text + " ", "")
    
    this.props.handlePost({
        content,
        title: this.state.title,
        excerpt
    })
  }

  handleSave = () => {
    console.log('handleSave called!')
    var contentState = this.state.editorState.getCurrentContent();
    const content = convertToRaw(contentState)
    const excerpt = this.state.customExcerpt || content.blocks.reduce((acc, curr) => acc += curr.text + " ", "")
    
    this.props.handleSave({
        content,
        title: this.state.title,
        excerpt
    })
  }

  showPhotoModal = () => {
    // console.log('called to showPhotoModal!')
    this.setState({showPhotoModal:true});
  }

  closePhotoModal = () => {
    // console.log('called to closePhotoModal!')
    this.setState({showPhotoModal:false});
  }

  renderPostButtons = () => {
    return(
      <div className="post-button-container">  
        {/* {<ExcerptEditor
          // update={(excerpt)=>this.setState({ customExcerpt: excerpt })}
          getExcerpt={()=>{

            // if( this.state.customExcerpt ){
            //   return this.state.customExcerpt
            // }

            const contentState = this.state.editorState.getCurrentContent();
            const content = convertToRaw(contentState)
            return content.blocks.reduce((acc, curr) => acc += curr.text + " ", "")

          }}
        />} */}
        <Button
          onClick={()=>{
            info({
              centered: true,
              icon: false,
              title: "Excerpt",
              content: this.props.getExcerpt(convertToRaw(this.state.editorState.getCurrentContent()))
            })
          }}
        >
            Excerpt
        </Button>
        <Button 
            style={{marginLeft: 8}}
            onClick={this.handlePost}
            type="primary">Post</Button>
        {this.props.activeDoc && <Button 
            style={{marginLeft: 8}}
            onClick={this.handleSave}
            >Save</Button>}
      </div>
    )
  }
   
  render() {
    const {editorState} = this.state;
    // If the user changes block type before entering any text, we can
    // either style the placeholder or hide it. Let's just hide it now.
    let className = 'RichEditor-editor';
    var contentState = editorState.getCurrentContent();

    if (!contentState.hasText()) {
      if (contentState.getBlockMap().first().getType() !== 'unstyled') {
        className += ' RichEditor-hidePlaceholder';
      }
    }

    return (
        [
        <style dangerouslySetInnerHTML={{ __html:`
        ${editorStyles}
        ` }} />,
        
        !this.props.readOnly ? 
        <div className="RichEditor-root">
          <div>
            <Affix offsetTop={0}>
            <div className="editorControls-container">
            <div className="editorControls-row">
                <Input
                    style={{width: 400}}
                    value={this.state.title}
                    placeholder="Title"
                    onChange={(e)=>this.setState({title: e.target.value})}
                />
                {this.props.loading && <Spin style={{marginLeft: 8}}/>}
              {this.renderPostButtons()}
            </div>

            <div className="editorControls-row">
              <BlockStyleControls
                    editorState={editorState}
                    onToggle={this.toggleBlockType}
                    />
              <InlineStyleControls
                  editorState={editorState}
                  onToggle={this.toggleInlineStyle}
                  children={            
                  <Tooltip title="Upload Media">
                    <Button
                    disabled={this.props.loading}
                    type="primary" onClick={this.showPhotoModal}>
                      <Icon type="picture" />
                    </Button>
                  </Tooltip>
                  }
              />
            </div>
            </div>

            {
              this.state.showPhotoModal ? (
                  <PhotoModal
                      videos={this.state.videos}
                      images={this.state.images}
                      visible={this.state.showPhotoModal}
                      closePhotoModal={this.closePhotoModal}
                      onAddImage={this.onAddImage}
                      onAddVideo={this.onAddVideo}
                      source={'doc'} // will be either 'doc' or 'community' -> to know which s3 bucket to upload to
                  />
              ) : null
            }
            </Affix>
            <div className={className} onClick={this.focus}>
                <Editor
                blockStyleFn={getBlockStyle}
                customStyleMap={styleMap}
                editorState={editorState}
                handleKeyCommand={this.handleKeyCommand}
                keyBindingFn={this.mapKeyToEditorCommand}
                onChange={this.onChange}
                onTab={this.onTab}
                // blockRendererFn={mediaBlockRenderer}
                plugins={plugins}
                ref="editor"
                spellCheck={true}
                />
                <InlineToolbar>
                  {
                    // may be use React.Fragment instead of div to improve perfomance after React 16
                    (externalProps) => (
                      <div>
                        <linkPlugin.LinkButton {...externalProps} />
                      </div>
                    )
                  }
                </InlineToolbar>
                <AlignmentTool />
            </div>
        </div>

        <Divider style={{height:'1px', background:'#ddd', margin:'9px 0'}}/>

        {this.renderPostButtons()}

        </div>

        : 
        <Editor
        readOnly
        editorState={editorState}
        blockRendererFn={mediaBlockRenderer} // so that h2 tags will have an id prop tagged to them
        plugins={plugins}
        onChange={this.onChange}
        ref="editor"
        />
        ]
    );

  }
}



// Custom overrides for "code" style.
const styleMap = {
    CODE: {
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
      fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
      fontSize: 16,
      padding: 2,
    },
  };

function getBlockStyle(block) {
  switch (block.getType()) {
    case 'blockquote': return 'RichEditor-blockquote';
    default: return null;
  }
}

class StyleButton extends React.Component {
  constructor() {
    super();
    this.onToggle = (e) => {
      e.preventDefault();
      this.props.onToggle(this.props.style);
    };
  }
  render() {
    let className = 'RichEditor-styleButton';
    if (this.props.active) {
      className += ' RichEditor-activeButton';
    }
    return (
      <span className={className} onMouseDown={this.onToggle}>
        {this.props.label}
      </span>
    );
  }
}

const BLOCK_TYPES = [
  {label: <Tooltip title="Block Quote"><span>Blockquote</span></Tooltip>, style: 'blockquote'},
  // {label: <Tooltip title="Unordered List"><Icon type="unordered-list"/></Tooltip>, style: 'unordered-list-item'},
  // {label: <Tooltip title="Ordered List"><Icon type="ordered-list"/></Tooltip>, style: 'ordered-list-item'},
  {label: <Tooltip title="Code Block"><span>Code Block</span></Tooltip>, style: 'code-block'},
];

const HEADER_TYPES = [
  {label: 'H1', style: 'header-one'},
  {label: 'H2', style: 'header-two'},
  {label: 'H3', style: 'header-three'},
  {label: 'H4', style: 'header-four'},
  {label: 'H5', style: 'header-five'},
  {label: 'H6', style: 'header-six'},
];

const BlockStyleControls = (props) => {
  const {editorState} = props;
  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();
  return (
    <div className="RichEditor-controls">
      <Row type="flex" justify="start">
        <Col>
          <div className="headerStyleDropdown">
            <HeaderStyleDropdown
              headerOptions={HEADER_TYPES}
              active={blockType}
              onToggle={props.onToggle}
            />
          </div>
        </Col>
        <Col>
          {BLOCK_TYPES.map((type) =>
            <StyleButton
              key={type.style}
              active={type.style === blockType}
              label={type.label}
              onToggle={props.onToggle}
              style={type.style}
            />
          )}
        </Col>
      </Row>
    </div>
  );
};

var INLINE_STYLES = [
  {label: <Tooltip title="Bold"><Icon type="bold"/></Tooltip>, style: 'BOLD'},
  {label: <Tooltip title="Italic"><Icon type="italic"/></Tooltip>, style: 'ITALIC'},
  {label: <Tooltip title="Underline"><Icon type="underline"/></Tooltip>, style: 'UNDERLINE'},
  {label: <Tooltip title="Code"><Icon type="code"/></Tooltip>, style: 'CODE'},
];

const InlineStyleControls = (props) => {
  const currentStyle = props.editorState.getCurrentInlineStyle();
  const {children} = props;
  
  return (
    <div className="RichEditor-controls">
      {INLINE_STYLES.map((type) =>
        <StyleButton
          key={type.style}
          active={currentStyle.has(type.style)}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
        />
      )}
      {children}
    </div>
  );
};
  
export default EezeeEditor;


// WEBPACK FOOTER //
// ./src/components/docs/editor.js